module.exports = __webpack_public_path__ + "static/joinBG.8ed4c59a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/joinBG.jpg
// module id = 842
// module chunks = 20897638506783